import React from "react";
import DatePicker from "DatePicker";

const ReportFilters = ({
  filters,
  stores,
  selectedItems,
  itemSearch,
  itemSuggestions,
  showSuggestions,
  itemLabel,
  itemPlaceholder,
  onFilterChange,
  onItemSearchChange,
  onItemSelect,
  onItemRemove,
  onClearAllItems,
  onFocus,
  onBlur,
}) => {
  return (
    <div className="Card s-card filters-card">
      <div className="columns is-multiline mb-1">
        <div className="column is-3">
          <label className="label">From Date</label>
          <DatePicker
            value={filters.fromDate}
            input_type="datetime"
            onChange={(date) => onFilterChange("fromDate", date)}
            placeholder="From"
          />
        </div>

        <div className="column is-3">
          <label className="label">To Date</label>
          <DatePicker
            value={filters.toDate}
            input_type="datetime"
            onChange={(date) => onFilterChange("toDate", date)}
            placeholder="To"
          />
        </div>

        <div className="column is-3">
          <label className="label">Store</label>
          <select
            className="input"
            value={filters.storeId}
            onChange={(e) => onFilterChange("storeId", e.target.value)}
          >
            <option value="">All Stores</option>
            {stores.map((store) => (
              <option key={store.id} value={store.id}>
                {store.name}
              </option>
            ))}
          </select>
        </div>

        <div className="column is-3">
          <label className="label">{itemLabel}</label>
          <div className="item-autocomplete">
            <input
              className="input"
              type="text"
              value={itemSearch}
              onChange={onItemSearchChange}
              onFocus={onFocus}
              onBlur={onBlur}
              placeholder={itemPlaceholder}
            />
            {showSuggestions && itemSuggestions.length > 0 && (
              <div className="suggestions-dropdown">
                {itemSuggestions.map((item) => (
                  <div
                    key={item.id}
                    className="suggestion-item"
                    onClick={() => onItemSelect(item)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedItems.length > 0 && (
        <div className="selected-items">
          <span className="label mr-2">Filtered {itemLabel}:</span>
          {selectedItems.map((item) => (
            <span key={item.id} className="tag is-primary is-medium mr-1">
              {item.name}
              <button
                className="delete is-small"
                onClick={() => onItemRemove(item.id)}
              />
            </span>
          ))}
          <button
            className="button is-small is-text"
            onClick={onClearAllItems}
          >
            Clear All
          </button>
        </div>
      )}
    </div>
  );
};

export default ReportFilters;
